<template>
    <div class="terms flex justify-center">
        <div class="mw7">
            <button class="backButton">
                <router-link class="rlink" :to="{name:'home'}">Volver</router-link>
            </button>
            <h1 class="mainTitleTyCandPolicy">Política de Propiedad Intelectual</h1>
            <div class="mainContentTyCandPolicy">
                Beathey ha adoptado la siguiente política general hacia las reclamaciones de infracción en materia
                de propiedad intelectual propiedad de o controlada por terceros de conformidad con la  Ley de
                Derechos de Autor del Milenio Digital . La dirección del agente designado de la empresa para
                recibir la notificación de la infracción reclamada ("Agente Designado") aparece al final de esta
                política.
                Es política de Beathey (1) bloquear el acceso a, o eliminar el material que entienda de buena fe
                que es propiedad intelectual de un tercero (por ejemplo, derechos de autor, marcas, secretos
                comerciales, etc.) que se han copiado y distribuido de manera ilegal por cualquiera de nuestros
                anunciantes, afiliados, proveedores de contenido, miembros o usuarios; y (2) retirar y suspender
                el servicio a los reincidentes. Un infractor reincidente es un usuario para el que Beathey ha
                recibido más de dos avisos de supuestas infracciones o para los que Beathey ha tenido que
                eliminar el contenido más de dos veces. A pesar de lo anterior, Beathey se reserva el derecho de
                interrumpir la cuenta de cualquier usuario por actividades ilícitas graves en la determinación
                exclusiva y discreción de Beathey.

                <h3>A. Procedimiento para la presentación de informes invocó la infracción:</h3>

                Si cree que el material o contenido que se encuentre o sea accesible a través del Sitio Web infringe
                un derecho de propiedad intelectual que Ud. posea o controle, por favor, envíe un aviso de
                infracción que contenga solamente la siguiente información al agente mencionado abajo. Tenga
                en cuenta que usted será responsable de los daños, incluidos los gastos y honorarios de abogados,
                si afirma que el contenido o una actividad infringe sus derechos de autor. Su comunicación debe
                incluir todos los siguientes elementos:

                <ol>
                    <li>Una firma física o electrónica de una persona autorizada para actuar en nombre
                del propietario de la obra que ha sido supuestamente infringido;</li>
                    <li>Identificación de las obras o materiales que se ha infringido;</li>
                    <li>La identificación del material que presuntamente infrinja derechos de propiedad
                intelectual, incluyendo la ubicación de aquel material que el propietario solicita
                remover, con el suficiente detalle para que la empresa sea capaz de encontrar y
                verificar su existencia; Proporcionar URL en el cuerpo de un correo electrónico
                es la mejor manera de ayudar a localizar el contenido rápidamente.</li>
                    <li>Información lo suficientemente razonable que nos permita ponernos en contacto
                con usted, como una dirección, número de teléfono y, si está disponible, una
                dirección de correo electrónico donde usted pueda ser contactado;</li>
                    <li>Si denuncia una infracción a los derechos de autor, una declaración que diga:
                &quot;Juro, bajo pena de perjurio que soy el propietario del copyright o estoy
                autorizado para actuar en nombre del propietario de un derecho exclusivo que
                presuntamente se ha infringido, y que la información de esta notificación es
                exacta. Entiendo de buena fe que el uso de los materiales protegidos descritos
                anteriormente como presuntamente infractores no está autorizado por el
                propietario de los derechos de autor, su agente o la ley &quot;.</li>
                <li>Si denuncia una infracción de marca, una declaración que diga: &quot;Juro, bajo pena
    de perjurio que soy el propietario de la marca o estoy autorizado para actuar en
    nombre del propietario de un derecho exclusivo que presuntamente se ha
    infringido, y que la información de esta notificación es exacta. Entiendo de buena
    fe que el uso de los materiales descritos anteriormente no está autorizado por el
    propietario de los derechos de autor, su agente o la ley &quot;.</li>
                </ol>

                Tenga en cuenta que una copia de su aviso legal se enviará a la persona obligada a suministrar el
    supuesto contenido infractor.
                Por favor no incluya ninguna información en su informe aparte de los elementos anteriores.

                <h3>B. Una vez que la notificación de infracción es recibida por el agente designado:</h3>
                Es política de la Beathey:

                <ol>
                    <li>eliminar o desactivar el acceso al material infractor;</li>
                    <li>notificar al proveedor de contenido, miembro o usuario de que se ha eliminado o
                desactivado el acceso al material; y</li>
                    <li>eliminar del sistema el material infractor proporcionado por los reincidentes, y
                Beathey dará por terminado el acceso al sistema a los proveedores o usuarios del
                material infractor.</li>
                </ol>

                <h3>C. Procedimiento para suministrar una descargo a la notificación al agente designado:</h3>

                Si el proveedor de contenidos, miembro o usuario cree que el material que se ha eliminado, o
                cuyo acceso se ha deshabilitado, o bien no está infringiendo derechos, o el proveedor de
                contenidos, miembro o usuario cree que tiene el derecho a publicar y utilizar dicho material
                propiedad del titular de los derechos de la propiedad intelectual, o de conformidad con la ley, el
                proveedor de contenidos, miembro o usuario debe enviar una contranotificaciòn que contenga la
                siguiente información al agente mencionado a continuación:

                <ol>
                    <li>Una firma física o electrónica del proveedor de contenido, miembro o usuario;</li>
                    <li>La identificación del material que ha sido eliminado o cuyo acceso ha sido
                inhabilitado y el lugar en el que apareció el material antes de ser retirado o
                desactivado;</li>
                    <li>Una declaración del proveedor de contenidos, miembro o usuario manifestando
                de buena fe que el material fue eliminado o inhabilitado como consecuencia de un
                error o una identificación errónea del material; y</li>
                    <li>Datos del proveedor de contenido, usuario o miembro, y, en su caso, dirección de
                correo electrónico y una declaración de que dicha persona o entidad acepta la
                jurisdicción de la Corte Federal del distrito judicial en el que el proveedor de
                contenidos, miembro o usuario tenga su domicilio, o si, la dirección de usuario o
                proveedor de contenidos o miembro se encuentra fuera de los Estados Unidos, por
                cualquier distrito judicial en el que se encuentra la empresa, y que dicha persona o entidad aceptará la notificación de la demanda/actos procesales de la persona que
                brindó la notificación de la presunta violación.</li>
                </ol>

                Si una contranotificación es recibida por el agente designado, Beathey puede enviar una copia de
                la contranotificación al reclamante inicial informando que Beathey puede reemplazar el material
                retirado o volver a habilitar el acceso a ella en 10 días hábiles. A menos que el propietario inicie
                una acción judicial para obtener una orden judicial contra el proveedor de contenidos, miembro o
                usuario, el material extraído se puede sustituir o restituir su acceso a ella en 10 a 14 días hábiles o
                más después de la recepción de la respuesta a una notificación, a discreción de la empresa.
                Por favor, póngase en contacto con Agente designado por la empresa para recibir la notificación
                de la infracción reclamada en la siguiente dirección:  copyright@Beathey.com  , o por correo a:
                
                <p>Las quejas DMCA<br>
                Beathey<br> 
                *******<br> 
                *********</p>

                Por favor tener en cuenta que podemos procesar las reclamaciones presentadas por correo
                electrónico a <a href="mailto:copyright@beathey.com">copyright@beathey.com</a>  mucho más rápidamente que las presentadas a la dirección
                arriba señalada.
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'intellectualProp-es'
  }
</script>

<style lang="scss" scoped>
  @import '~@/variables.scss';

  @font-face {
    font-family: 'Titillium Web';
    src: url('../../assets/fonts/TitilliumWeb-Bold.eot');
    src: url('../../assets/fonts/TitilliumWeb-Bold.eot?#iefix') format('embedded-opentype'),
    url('../../assets/fonts/TitilliumWeb-Bold.woff2') format('woff2'),
    url('../../assets/fonts/TitilliumWeb-Bold.woff') format('woff'),
    url('../../assets/fonts/TitilliumWeb-Bold.ttf') format('truetype'),
    url('../../assets/fonts/TitilliumWeb-Bold.svg#TitilliumWeb-Bold') format('svg');
    font-weight: bold;
    font-style: normal;

  }

  @font-face {
    font-family: 'Titillium Web';
    src: url('../../assets/fonts/TitilliumWeb-Regular.eot');
    src: url('../../assets/fonts/TitilliumWeb-Regular.eot?#iefix') format('embedded-opentype'),
    url('../../assets/fonts/TitilliumWeb-Regular.woff2') format('woff2'),
    url('../../assets/fonts/TitilliumWeb-Regular.woff') format('woff'),
    url('../../assets/fonts/TitilliumWeb-Regular.ttf') format('truetype'),
    url('../../assets/fonts/TitilliumWeb-Regular.svg#TitilliumWeb-Regular') format('svg');
    font-weight: normal;
    font-style: normal;
  }

  html {
    height: 100%;
  }

  body {
    margin: 0;
    background-color: #393839;
    height: 100%;
    overflow: hidden;
  }

  a{
    color: $text-color
  }

  .terms {
    font-family: 'Titillium Web', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #AAA;
    background-color: #393839;
    height: 100%;
    width: 100vw;
    line-height: normal;
  }

  .rlink {
    text-decoration: none !important;
    color: #000;
  }

  .backButton {
    margin: 1rem;
    background: #aaa;
  }
.mainTitleTyCandPolicy {
      text-align: center;
  }
  .mainContentTyCandPolicy{
      padding: 1rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/policy/IntellectualPropEs.vue